<!-- SUMMARY + CHART FLEX LAYOUT -->
<div style="min-height: 90%">
<div class="top-section" *ngIf="!loading">
  <!-- Left Card: Summary -->
  <mat-card *ngIf="summary$ | async as summary" class="summary-wrapper">
    <mat-card-content class="summary-card">
  
      <div class="card-top">
        <!-- <img src="assets/img/auresscan.png" alt="logo" class="logo" />
   -->
        <div class="summary-row">
          <div class="summary-block">
            <div class="summary-label">Blockchains Created</div>
            <div class="summary-value">{{ summary.totalCount }}</div>
          </div>
  
          <div class="summary-block">
            <div class="summary-label">Value Delivered</div>
            <div class="summary-value">
              ${{ formatNumberWithCommas(summary.totalAmountTxn) }}
            </div>
          </div>
        </div>
  
      </div>
  
    </mat-card-content>
  </mat-card>
  

  <!-- Right Card: Chart -->
  <!-- <mat-card class="chart-wrapper" *ngIf="!loading">
    <mat-card-content class="chart-card" style="background-color: #fff;">
      <google-chart
        class="google-chart-container"
        [title]="chartOptions.title"
        [type]="chartType"
        [data]="chartData"
        [columns]="chartColumns"
        [options]="chartOptions">
      </google-chart>
    </mat-card-content>
  </mat-card> -->
</div>

<!-- LOADING SPINNER -->
 <div class="loading-section" *ngIf="loading">
  <mat-spinner diameter="50"></mat-spinner>
</div> 

<!-- TRANSACTIONS: TABLE ON DESKTOP, CARD LIST ON MOBILE -->
<div class="transactions-section" *ngIf="!loading">
  
  <!-- DESKTOP TABLE -->
  <div *ngIf="!isMobile" class="table-container">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">

      <!-- Txn# -->
      <ng-container matColumnDef="txnNum">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Txn#</th>
        <td mat-cell *matCellDef="let element">
          <i class="fa fa-indent"></i>
          <span class="clickable" [matTooltip]="element.txnNum"
                (click)="clickTxnHashOnHTMLPage(element.txnNum)">
            0X{{ getMaskedRightPart(element.txnNum) }}
          </span>
        </td>
      </ng-container>

      <!-- Method -->
      <ng-container matColumnDef="txnOperation">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Method</th>
        <td mat-cell *matCellDef="let element">
          {{ getTransactionMethod(element.txnOperation | titlecase, element.redeemedGoldName) }}
        </td>
      </ng-container>

      <!-- Date -->
      <ng-container matColumnDef="creationDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element.creationDate ? (element.creationDate | date:'MM/dd/yyyy') : "" }}
        </td>
      </ng-container>

      <!-- From -->
      <ng-container matColumnDef="senderHex">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>From</th>
        <td mat-cell *matCellDef="let element" [matTooltip]="element.senderHex">
          0X{{ getMaskedString(element.senderHex) }}
        </td>
      </ng-container>

      <!-- To -->
      <ng-container matColumnDef="receiverHex">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>To</th>
        <td mat-cell *matCellDef="let element" [matTooltip]="element.receiverHex">
          0X{{ getMaskedString(element.receiverHex) }}
        </td>
      </ng-container>

      <!-- Token Type -->
      <ng-container matColumnDef="txnType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Stablecoins & Tokens</th>
        <td mat-cell *matCellDef="let element"><img class="rounded-circle" style="width: 35px" src="{{ element.coinLogoUrl }}" alt="activity-user" />&nbsp;{{ element.txnType }}
          <p class="mb-1 text-muted" style="margin-left:40px;line-height: 6px;">{{element.coin_symbol}}</p>
        </td>
      </ng-container>

      <!-- Quantity -->
      <ng-container matColumnDef="coinsqty">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Quantity</th>
        <td mat-cell *matCellDef="let element" class="text-right">
          {{ element.coinsqty }}
        </td>
      </ng-container>

      <!-- Amount -->
      <ng-container matColumnDef="totalAmountTxn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
        <td mat-cell *matCellDef="let element" class="text-right">
          ${{ formatNumberWithCommas(element.totalAmountTxn) }}
        </td>
      </ng-container>

      <!-- Header & Row -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns" style="height:45px"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <!-- No Records -->
    <div class="no-record" *ngIf="dataSource?.data?.length === 0">
      No Record Found
    </div>

    <mat-paginator #desktopPaginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons>
    </mat-paginator>
  </div>

  <!-- MOBILE CARDS -->
  <div *ngIf="isMobile" class="mobile-cards">

    <mat-card *ngFor="let element of dataSource?.data" class="txn-card mat-elevation-z1">
      <mat-card-content>
        <div class="row"><div><strong>Txn#:</strong></div><div class="val">
          <span class="clickable" [matTooltip]="element.txnNum"
                (click)="clickTxnHashOnHTMLPage(element.txnNum)">
            0X{{ getMaskedRightPart(element.txnNum) }}
          </span>
        </div></div>

        <div class="row"><div><strong>Method:</strong></div><div class="val">{{ getTransactionMethod(element.txnOperation | titlecase, element.redeemedGoldName) }}</div></div>
        <div class="row"><div><strong>Date:</strong></div><div class="val">{{ element.creationDate ? (element.creationDate | date:'dd/MM/yyyy') : "" }}</div></div>
        <div class="row"><div><strong>From:</strong></div><div class="val">0X{{ getMaskedString(element.senderHex) }}</div></div>
        <div class="row"><div><strong>To:</strong></div><div class="val">0X{{ getMaskedString(element.receiverHex) }}</div></div>
        <div class="row"><div><strong>Token:</strong></div><div class="val"><img class="rounded-circle" style="width: 35px" src="{{ element.coinLogoUrl }}" alt="activity-user" />&nbsp;{{ element.txnType }}
         </div></div>
        <div class="row"><div><strong>Qty:</strong></div><div class="val">{{ element.coinsqty }}</div></div>
        <div class="row"><div><strong>Amount:</strong></div><div class="val">${{ formatNumberWithCommas(element.totalAmountTxn) }}</div></div>
      </mat-card-content>
    </mat-card>

    <!-- No Records -->
    <div class="no-record" *ngIf="dataSource?.data?.length === 0">
      No Record Found
    </div>

    <mat-paginator #mobilePaginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
</div>
<router-outlet></router-outlet>
